import { render, staticRenderFns } from "./CustomerEngagement.vue?vue&type=template&id=23c6e39a&scoped=true&"
import script from "./CustomerEngagement.vue?vue&type=script&lang=js&"
export * from "./CustomerEngagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c6e39a",
  null
  
)

export default component.exports